import React from 'react';
import {
  Box,
  HStack,
  VStack,
  Text,
  Select,
  Badge,
  IconButton,
  Tooltip,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';
import { FiFilter, FiRefreshCw, FiMapPin, FiUsers } from 'react-icons/fi';

const DashboardFilterBar = ({ 
  selectedBranch, 
  onBranchChange, 
  branches = [], 
  totalEmployees = 0,
  onRefresh,
  isLoading = false 
}) => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.300');

  const getBranchDisplayName = (branchId) => {
    if (branchId === 'all') return 'All Branches';
    const branch = branches.find(b => b.branch_id === branchId);
    return branch ? branch.name : 'Unknown Branch';
  };

  const getBranchEmployeeCount = (branchId) => {
    if (branchId === 'all') return totalEmployees;
    const branch = branches.find(b => b.branch_id === branchId);
    return branch ? branch.total_employees : 0;
  };

  return (
    <Box
      bg={bgColor}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="lg"
      p={3}
      shadow="sm"
    >
      <HStack spacing={4} align="center" justify="space-between">
        {/* Branch Filter with inline icon */}
        <HStack spacing={3} align="center">
          <HStack spacing={2} align="center">
            <FiMapPin size={16} color="#6B7280" />
            <Select
              value={selectedBranch}
              onChange={(e) => onBranchChange(e.target.value)}
              size="sm"
              borderRadius="md"
              borderColor="gray.300"
              _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px #3182CE' }}
              isDisabled={isLoading}
              minW="200px"
            >
              <option value="all">All Branches</option>
              {branches.map((branch) => (
                <option key={branch.branch_id} value={branch.branch_id}>
                  {branch.name} ({branch.total_employees || 0} employees)
                </option>
              ))}
            </Select>
          </HStack>

          {/* Current Selection Info */}
          <HStack spacing={2} align="center">
            <Text fontSize="sm" color="gray.600">
              Viewing:
            </Text>
            <Badge colorScheme="blue" variant="subtle" fontSize="sm">
              {getBranchDisplayName(selectedBranch)}
            </Badge>
            <HStack spacing={1} align="center">
              <FiUsers size={12} color="#6B7280" />
              <Text fontSize="sm" color="gray.600">
                {getBranchEmployeeCount(selectedBranch)} employees
              </Text>
            </HStack>
          </HStack>
        </HStack>

        {/* Refresh Button */}
        <Tooltip label="Refresh data" placement="top">
          <IconButton
            icon={<FiRefreshCw />}
            size="sm"
            variant="ghost"
            colorScheme="gray"
            onClick={onRefresh}
            isLoading={isLoading}
            aria-label="Refresh data"
          />
        </Tooltip>
      </HStack>
    </Box>
  );
};

export default DashboardFilterBar; 